import { CancelToken, isCancel } from 'axios'
import { sortItems } from '@/sorting/OpportunityLocation'

export const getters = {}

export default {
  namespaced: true,

  state: {
    // The Opportunities currently visible
    all: [],
    // Current geolocation
    geoCenter: null,
    // What filters are currently applied
    filters: {},
    // Used to indicate when waiting on the server
    loading: false,
    // Size of current page beign viewed
    search: '',
    // Token source used to abandon requests
    source: null,
  },

  getters,

  mutations: {
    setAll(state, { items = [], search = null, filters = {}, geoCenter = null }) {
      state.search = search
      items = geoCenter ? sortItems(items, geoCenter.geoCenter) : items
      state.all = items
      state.filters = filters
      state.loading = false
    },

    set(state, opportunityLocation) {
      const find = state.all.find(location => location.id == opportunityLocation.id)
      if (find) state.all.splice(state.all.indexOf(find), 1, opportunityLocation)
      if (!find) state.all.push(opportunityLocation)
    },

    clearAll(state) {
      state.all = []
    },
  },

  actions: {
    search({ commit, state }, { filters, opportunity, geoCenter } = {}) {
      if (state.source) {
        state.source.cancel()
      }
      geoCenter = geoCenter || state.geoCenter
      filters = filters || state.filters
      state.source = CancelToken.source()

      state.loading = true
      return Vue.$http
        .get(`candidate/opportunity_locations`, {
          params: { ...filters, geoCenter },
          cancelToken: state.source.token,
        })
        .then(
          response => {
            commit('setAll', { ...response.data, geoCenter })
            return response
          },
          errors => {
            if (!isCancel(errors)) state.loading = false
          }
        )
    },

    updateFilters({ dispatch, state }, { filters = {} }) {
      if (filters) {
        state.filters = state.filters ? state.filters : {}
        Object.assign(state.filters, { ...filters })
      }
      return dispatch('search').then(response => response)
    },
  },
}
